import Modal from '~/javascripts/components/Modal';
import { render } from 'react-dom';

export default function ($toggleEl) {
  const maybeMountModalElement = () => {
    const id = $toggleEl.attr('href');
    const $modalEl = $(id);

    // only mount one modal per unique Modal behavior (unique by href)
    if ($(`${id}-react`).length) return true;

    $('body').append(`<span id="${id.split('#')[1]}-react"><span>`);

    render(
      <Modal
        autoOpen={$modalEl.data('auto-open')}
        autoOpenOnDesktopOnly={$modalEl.data('auto-open-on-desktop-only')}
        containerClassName={$modalEl.data('modal-class')}
        disableClickOutsideToClose={$modalEl.data(
          'disable-click-outside-to-close'
        )}
        disableEscapeToClose={$modalEl.data('disable-escape-to-close')}
        disableHistory={$modalEl.data('disable-history')}
        hideCloseModal={$modalEl.data('hide-close-modal')}
        modalId={id.replace('#', '')}
        modalInnerClassName={$modalEl.data('modal-inner-class-name')}
        modalName={
          $modalEl.data('name') || id.replace('#', '').replace('-', ' ')
        }
        onCloseCallback={eval($modalEl.data('on-close-callback'))}
        ref={(el) => (window.modal.instances[id] = el)}
        trackingInfo={$modalEl.data('tracking-info')}
      >
        <span dangerouslySetInnerHTML={{ __html: $modalEl.html() }} />
      </Modal>,
      $(`${id}-react`)[0]
    );

    $modalEl.remove();
  };

  const attachClickHandler = () => {
    $toggleEl.on('click', (event) => {
      event.preventDefault();

      if ($(event.target).data('disabled')) {
        return;
      }

      window.modal.toggle($toggleEl.attr('href'));
    });
  };

  attachClickHandler();
  maybeMountModalElement();
}
